import jQuery from 'jquery';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;

UI.View({
    name: 'order_address',
    model: Order,
    el: '[data-view="order-address"]',
    template: jQuery('[data-template="order-address"]').html(),
    initialise() {},
    model_listeners: {
        updateCustomer(customer) {
            customer && this.render();
        },
        updateMethod: 'render',
        updateAddress: 'render',
    },
    render() {
        const that = this;
        const html = this.template(Order);

        this.$el.html(html); // Insert html into DOM

        this.trigger('orderAddressViewRendered');
    },

    // When the dropdown changes, set the order method of the order
    DOM_listeners: {
        'click [data-order-delivery-address]': function() {
            Mobi2Go.UI.trigger('showCustomerAddresses');
        },
    },
});
